import { render, staticRenderFns } from "./novaWeb.vue?vue&type=template&id=9571c074"
import script from "./novaWeb.vue?vue&type=script&lang=js"
export * from "./novaWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports